import useAppDispatch from "../../hooks/useAppDispatch";
import { closeModal } from "../../redux/slices/uiSlice";
import { useQuery } from "@tanstack/react-query";
import { getHowToPlayStepListAPI } from "../../api/user";
import useToast from "../../hooks/useToast";
import Loader from "../Loader/Loader";
import { useTranslation } from "react-i18next";

const PlayInfo = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  // Don't render anything if modal is not open
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { data, isLoading, error } = useQuery({
    queryKey: ["how-to-play-step-list", currentLanguage],
    queryFn: getHowToPlayStepListAPI,
  });

  const steps = data?.data?.map((step: any) => ({
    number: step.step_no,
    title: step.title,
    description: step.description,
  }));

  return (
    <>
      <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
        {/* Modal Content */}
        <div className="modal bg-white-500 lg:rounded-[1.5vw] rounded-3xl lg:p-[2vw] md:p-7 p-4 2xl:max-w-[30vw] max-w-116  w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary auth-page overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] hide-scroll">
          <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full 2xl:mb-[1vw] md:mb-0 mb-3">
            <h1 className="2xl:text-[1.9vw]/[2.2vw] text-2xl/6 font-semibold text-primary-orange">{t("home.howToPlayGames")}</h1>
            {/* Close Button */}
            <button
              onClick={() => dispatch(closeModal())}
              className="focus:outline-none lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto hover:scale-110 transition-transform duration-300"
            >
              <svg
                className="w-full h-full"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                  fill="#333938"
                />
              </svg>
            </button>
          </div>
          <hr className="border-0 2xl:h-[0.053vw] h-[1px] w-full 2xl:mb-[1vw] md:mb-4 mb-3 2xl:mt-[0.98vw] mt-4 [background:linear-gradient(90deg,rgba(11,51,105,0)_0%,#7364FF_50%,rgba(11,51,105,0)_100%)]" />

          {/* Content - Add your how to play instructions here */}
          {/* Steps */}
          <div className="lg:space-y-[1.042vw] space-y-5">
            {isLoading ? (
              <div className="flex justify-center items-center h-full">
                <Loader />
              </div>
            ) : (
              steps.map((step, index) => (
                <div key={index} className="flex lg:gap-[0.833vw] gap-4 items-start">
                  {/* Step Badge */}
                  <div className="flex-shrink-0">
                    <div className="bg-primary-yellow relative 2xl:py-[0.6vw] py-2 lg:px-[5%] px-4 flex
            2xl:rounded-[0.26vw] rounded-[5px]
            skew-x-[-10deg]
            2xl:border-[0.104vw] border-[1.5px]
            transition-all border-black-300 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] 2xl:min-w-[3.125vw] min-w-10 2xl:w-[3.125vw] w-10 2xl:h-[3.125vw] h-10 flex items-center justify-center">
                      <span className="2xl:mt-[0.208vw] mt-1 lg:text-[1.1vw]/none md:text-base/none text-sm/none font-bold skew-x-[10deg] text-black-300 placeholder:text-black-400 focus:outline-none transition-all disabled:opacity-50 bg-transparent  2xl:text-[1.042vw] text-lg ">
                        {step.number}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 lg:pt-[0.208vw] pt-1">
                    <h3 className="2xl:text-[1.12vw]/tight text-lg/tight text-black-300 lg:mb-[0.313vw] mb-1.5 font-bold">
                      {step.title}
                    </h3>
                    <p className="text-black-300 2xl:text-[0.938vw]/tight text-base/tight">{step.description}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default PlayInfo;
